//The js entry point that renders the app component th the DOM

import './Index.css';
import App from './App';

// Before
//import ReactDOM from 'react-dom';
// ReactDOM.render(
//     <App />,     //root component
//     document.getElementById('root')
// );


//after React 18
import { createRoot } from 'react-dom/client';
// Create a root for rendering
const root = createRoot(document.getElementById('root'));

// Render the root component
root.render(
  <App /> // Root component
);